import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment } from "react";
import Seo from "./seo";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import SubListSelector from "../../components/GameComponents/SubListSelector/SubListSelector";
import PlatformSelector from "../../components/GameComponents/PlatformSelector/PlatformSelector";

const Lottery = ({ gameMainTypeFromProps }) => {
  return (
    <Fragment>
      <Seo />
      <Box
        as="section"
        px="common-y"
        position="sticky"
        top={"70px"}
        zIndex={1}
        bgColor="rgba(0,0,0,0.3)"
        display={{ base: "block", xl: "none" }}
      >
        <GameTypeSelector />
      </Box>
      <Box as="section" pt="home-space" px="common-y">
        <SubListSelector
          forceShowAll
          gameMainTypeFromProps={gameMainTypeFromProps}
        />
      </Box>
      {/* <Box as="section" pt="home-space" px="common-y">
        <MarqueeListV2 />
      </Box> */}

      <Box
        mt={{
          md: "0px",
          // base: "10px",
        }}
        pt="home-space"
      >
        {/* <MobileSearch listHidden /> */}
      </Box>
      <Box overflowY="scroll" flex={1}>
        <Box pb="home-space" px="common-y">
          <PlatformSelector gameMainTypeFromProps={gameMainTypeFromProps} />
        </Box>
        <Box py="home-space" px="common-y">
          <GameSelector gameMainTypeFromProps={gameMainTypeFromProps} />
        </Box>
      </Box>
    </Fragment>
  );
};

export default Lottery;
